// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField {
  width: 100%;
  max-width: 318px;
}
.k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField #locationSearchInput {
  margin: 0 auto;
  max-width: 288px;
}
.k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField label {
  margin: 7px 0 4px 0;
  max-width: 288px;
}
@media (min-width: 846px) {
  .k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField {
    max-width: 100%;
    padding: 0 16px !important;
    margin-left: auto;
    margin-right: auto;
  }
  .k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField #locationSearchInput {
    max-width: none;
  }
  .k-form .dataCaptureSection .sectionContainer .k-form-field.addressLookupField label {
    margin: 7px 0 4px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/AddressLookupField.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EAGG,WAAA;EACA,gBAAA;AAUH;AAdA;EAOI,cAAA;EACA,gBAAA;AAUJ;AAlBA;EAWI,mBAAA;EACA,gBAAA;AAUJ;AANE;EAAA;IAEE,eAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;EAQF;EAbA;IAOG,eAAA;EASH;EAhBA;IAUG,mBAAA;EASH;AACF","sourcesContent":["@import '../../constants.less';\n\n.k-form .dataCaptureSection {\n\t.sectionContainer {\n\t\t.k-form-field.addressLookupField {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 318px;\n\n\t\t\t#locationSearchInput {\n\t\t\t\tmargin: 0 auto;\n\t\t\t\tmax-width: @inputWidth;\n\t\t\t}\n\t\t\tlabel {\n\t\t\t\tmargin: 7px 0 4px 0;\n\t\t\t\tmax-width: @inputWidth;\n\t\t\t}\n\t\t}\n\n\t\t@media (min-width: @dataCaptureTwoColumnFieldsPageMinWidth) {\n\t\t\t.k-form-field.addressLookupField {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tpadding: 0 16px !important;\n\t\t\t\tmargin-left: auto;\n\t\t\t\tmargin-right: auto;\n\t\t\t\t#locationSearchInput {\n\t\t\t\t\tmax-width: none;\n\t\t\t\t}\n\t\t\t\tlabel {\n\t\t\t\t\tmargin: 7px 0 4px 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
